import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchActivityTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/activity-types', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteActivityType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/activity-types/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
